import React from "react";
import Founder from "@/components/Founder";
import PageCTA from "@/components/PageCTA";

const FounderPage = () => (
  <div className="pt-24">
    <Founder />
    <PageCTA
      heading="Work directly with William."
      sub="Every NEX engagement starts with a Friction Audit personally reviewed by the founder — no gatekeepers, no salespeople."
      secondary={{ to: "/case-study", label: "See a Real Deploy" }}
    />
  </div>
);

export default FounderPage;
